// extracted by mini-css-extract-plugin
export var content = "ThreeColumnSection-module--content--58e05";
export var externalWrapper = "ThreeColumnSection-module--externalWrapper--140e9";
export var holder = "ThreeColumnSection-module--holder--1b189";
export var subTitle = "ThreeColumnSection-module--subTitle--ec0bd";
export var title = "ThreeColumnSection-module--title--0e4f6";
export var wrapper = "ThreeColumnSection-module--wrapper--bd9e4";